var map = {
	"./Air-Travel-gold.svg": [
		882,
		3
	],
	"./Air-Travel-private.svg": [
		883,
		4
	],
	"./Air-Travel.svg": [
		884,
		5
	],
	"./Bakeries-Cafe-gold.svg": [
		885,
		6
	],
	"./Bakeries-Cafe-private.svg": [
		886,
		7
	],
	"./Bakeries-Cafe.svg": [
		887,
		8
	],
	"./Car-Rental-gold.svg": [
		888,
		9
	],
	"./Car-Rental-private.svg": [
		889,
		10
	],
	"./Car-Rental.svg": [
		890,
		11
	],
	"./Catering-gold.svg": [
		891,
		12
	],
	"./Catering-private.svg": [
		892,
		13
	],
	"./Catering.svg": [
		893,
		14
	],
	"./Clothes-Shopping-gold.svg": [
		894,
		15
	],
	"./Clothes-Shopping-private.svg": [
		895,
		16
	],
	"./Clothes-Shopping.svg": [
		896,
		17
	],
	"./Convenience-Stores-gold.svg": [
		897,
		18
	],
	"./Convenience-Stores-private.svg": [
		898,
		19
	],
	"./Convenience-Stores.svg": [
		899,
		20
	],
	"./Drug-Stores-gold.svg": [
		900,
		21
	],
	"./Drug-Stores-private.svg": [
		901,
		22
	],
	"./Drug-Stores.svg": [
		902,
		23
	],
	"./Energy-gold.svg": [
		903,
		24
	],
	"./Energy-private.svg": [
		904,
		25
	],
	"./Energy.svg": [
		905,
		26
	],
	"./FOOD.svg": [
		906,
		27
	],
	"./Furniture-gold.svg": [
		907,
		28
	],
	"./Furniture-private.svg": [
		908,
		29
	],
	"./Furniture.svg": [
		909,
		30
	],
	"./General-gold.svg": [
		910,
		31
	],
	"./General-private.svg": [
		911,
		32
	],
	"./General.svg": [
		912,
		33
	],
	"./Groceries-gold.svg": [
		913,
		34
	],
	"./Groceries-private.svg": [
		914,
		35
	],
	"./Groceries.svg": [
		915,
		36
	],
	"./Home-gold.svg": [
		916,
		37
	],
	"./Home-private.svg": [
		917,
		38
	],
	"./Home.svg": [
		918,
		39
	],
	"./LIVING.svg": [
		919,
		40
	],
	"./Local-Transport-gold.svg": [
		920,
		41
	],
	"./Local-Transport-private.svg": [
		921,
		42
	],
	"./Local-Transport.svg": [
		922,
		43
	],
	"./Lodging-Accomodation-gold.svg": [
		923,
		44
	],
	"./Lodging-Accomodation-private.svg": [
		924,
		45
	],
	"./Lodging-Accomodation.svg": [
		925,
		46
	],
	"./OTHER.svg": [
		926,
		47
	],
	"./Online-Shopping-gold.svg": [
		927,
		48
	],
	"./Online-Shopping-private.svg": [
		928,
		49
	],
	"./Online-Shopping.svg": [
		929,
		50
	],
	"./SHOPPING.svg": [
		930,
		51
	],
	"./Service-Stations-gold.svg": [
		931,
		52
	],
	"./Service-Stations-private.svg": [
		932,
		53
	],
	"./Service-Stations.svg": [
		933,
		54
	],
	"./Streaming-gold.svg": [
		934,
		55
	],
	"./Streaming-private.svg": [
		935,
		56
	],
	"./Streaming.svg": [
		936,
		57
	],
	"./TRAVEL.svg": [
		937,
		58
	],
	"./Taxi-gold.svg": [
		938,
		59
	],
	"./Taxi-private.svg": [
		939,
		60
	],
	"./Taxi.svg": [
		940,
		61
	],
	"./Train-gold.svg": [
		941,
		62
	],
	"./Train-private.svg": [
		942,
		63
	],
	"./Train.svg": [
		943,
		64
	],
	"./Travel-Agencies-gold.svg": [
		944,
		65
	],
	"./Travel-Agencies-private.svg": [
		945,
		66
	],
	"./Travel-Agencies.svg": [
		946,
		67
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 872;
module.exports = webpackAsyncContext;